import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ArrowRight } from 'lucide-react'
import LoginFormCN from './LoginFormCN'
import CreateAccountCN from './CreateAccountCN'
import ChangePasswordCN from './ChangePasswordCN'
import EmailConfirmFormCN from './EmailConfirmCN'
import ForgotPasswordCN from './ForgotPasswordCN'
import RegisterConfirmFormCN from './RegisterConfirmCN'
import routes from 'constants/routes'
import { safeRedirect } from 'utils/safeRedirect'
import MDTLogo from 'images/MDT_FullLogo.png'

const LoginScreenCN = () => {
	const location = useLocation()
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()

	const userLogin = useSelector((state: any) => state.userLogin)
	const { userInfo } = userLogin

	// Only a path inside the app is followed; anything else goes home (MYD-541).
	const redirect = safeRedirect(searchParams.get('redirect'))
	useEffect(() => {
		if (userInfo) {
			navigate(redirect, { replace: true })
		}
	}, [navigate, userInfo, redirect])

	const isLoggedIn = userInfo !== null && userInfo !== undefined
	if (isLoggedIn) return null

	const { pathname } = location

	const renderForm = () => {
		if (pathname === routes.LOGIN) {
			return (
				<>
					<LoginFormCN />
					<div className="flex flex-col items-center mt-6">
						<Link
							to={routes.REGISTER}
							className="inline-flex items-center gap-1 text-[#0080fe] hover:text-[#0073e6] no-underline text-sm font-medium"
						>
							Create your account <ArrowRight className="w-4 h-4" />
						</Link>
					</div>
				</>
			)
		}
		if (pathname === routes.REGISTER) {
			return (
				<>
					<CreateAccountCN />
					<div className="flex flex-col items-center mt-6">
						<span className="text-sm text-gray-600">
							Have an account?{' '}
							<Link to={routes.LOGIN} className="text-[#0080fe] hover:text-[#0073e6] no-underline font-medium">
								Login
							</Link>
						</span>
					</div>
				</>
			)
		}
		if (pathname === routes.FORGOT_PASSWORD) {
			return (
				<>
					<ForgotPasswordCN />
					<div className="flex flex-col items-center mt-6">
						<Link
							to={routes.REGISTER}
							className="inline-flex items-center gap-1 text-[#0080fe] hover:text-[#0073e6] no-underline text-sm font-medium"
						>
							Create your account <ArrowRight className="w-4 h-4" />
						</Link>
					</div>
				</>
			)
		}
		if (pathname === routes.CHANGE_PASSWORD) {
			return (
				<>
					<ChangePasswordCN />
					<div className="flex flex-col items-center mt-6">
						<span className="text-sm text-gray-600">
							Have an account?{' '}
							<Link to={routes.LOGIN} className="text-[#0080fe] hover:text-[#0073e6] no-underline font-medium">
								Login
							</Link>
						</span>
					</div>
				</>
			)
		}
		if (pathname === routes.EMAIL_CONFIRM) {
			return (
				<>
					<EmailConfirmFormCN />
					<div className="flex flex-col items-center mt-6">
						<span className="text-sm text-gray-600">
							Have an account?{' '}
							<Link to={routes.LOGIN} className="text-[#0080fe] hover:text-[#0073e6] no-underline font-medium">
								Login
							</Link>
						</span>
					</div>
				</>
			)
		}
		if (pathname === routes.REGISTER_CONFIRM) {
			return (
				<>
					<RegisterConfirmFormCN />
					<div className="flex flex-col items-center mt-6">
						<span className="text-sm text-gray-600">
							Have an account?{' '}
							<Link to={routes.LOGIN} className="text-[#0080fe] hover:text-[#0073e6] no-underline font-medium">
								Login
							</Link>
						</span>
					</div>
				</>
			)
		}
		return null
	}

	return (
		<div className="min-h-screen flex items-center justify-center p-4 md:p-6 bg-[radial-gradient(circle,rgba(0,128,254,1)_30%,rgba(0,85,169,1)_100%)]">
			<div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 md:p-10">
				<div className="flex justify-center mb-6">
					<img src={MDTLogo} alt="MYDealTeams logo" className="w-72" />
				</div>
				{renderForm()}
			</div>
		</div>
	)
}

export default LoginScreenCN
